"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SuggestionText = exports.SuggestionOption = exports.InvisibleSuggestionOption = exports.TypeaheadPopover = exports.TypeaheadSearchContainer = void 0;
var storm_ui_1 = require("@amzn/storm-ui");
var styled_components_1 = __importDefault(require("styled-components"));
exports.TypeaheadSearchContainer = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n"], ["\n  width: 100%;\n"])));
exports.TypeaheadPopover = (0, styled_components_1.default)(storm_ui_1.Popover)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  width: ", ";\n  direction: ", ";\n"], ["\n  width: ", ";\n  direction: ", ";\n"])), function (_a) {
    var width = _a.width;
    return "".concat(width, "px");
}, function (_a) {
    var isRtl = _a.isRtl;
    return (isRtl ? 'rtl' : 'ltr');
});
exports.InvisibleSuggestionOption = (0, styled_components_1.default)(storm_ui_1.SelectOption)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: none;\n"], ["\n  display: none;\n"])));
exports.SuggestionOption = (0, styled_components_1.default)(storm_ui_1.SelectOption)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  width: 100%;\n  text-align: start;\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  gap: ", ";\n"], ["\n  width: 100%;\n  text-align: start;\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  gap: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.spacing.small;
});
exports.SuggestionText = (0, styled_components_1.default)(storm_ui_1.Text)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  padding: ", ";\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n"], ["\n  padding: ", ";\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.spacing.mini;
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
